import { useEffect, useState, FC } from 'react'
import { Prompt, useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Formik } from 'formik'
import * as Yup from 'yup'

import Api from 'services/Api'
import { Button, Select, Form } from 'components/Forms'
import { launchPunchTerminal } from 'store/actions/punchTerminal'
import { createErrorNotification } from 'store/actions/notifications'
import { decodeToken } from 'store/actions/auth'
import { Alert, Card } from 'ui'
import { Card as MerinioCard } from 'components/UI'

import { t } from 'translations'

const PunchLocation: FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const [locations, setLocations] = useState<
    {
      tag: string
      _id: string
      type: string
    }[]
  >([])

  const { isPunchToken } = useSelector((state: MStore.RootState) => state.punchTerminal)

  const PunchLocationShape = Yup.object().shape({ locationId: Yup.string() })

  useEffect(() => {
    async function fetchLocations() {
      const { result, success } = await Api('/tags/tags')
      if (!success) return dispatch(createErrorNotification())
      setLocations(result.filter((tag: { type: string }) => tag.type === 'locations'))
    }
    fetchLocations()
  }, [setLocations, dispatch])

  async function onSubmit({ locationId }) {
    await dispatch(launchPunchTerminal(locationId))
    history.push('/punch/auth')
  }

  useEffect(() => {
    const { punchToken } = decodeToken()
    if (punchToken) history.push('/punch/auth')
  }, [history])

  return (
    <MerinioCard title="punch.punchLocation.LOCATION_SELECTION">
      <Card.Body>
        <Formik
          enableReinitialize
          validationSchema={PunchLocationShape}
          initialValues={{ locationId: locations.length ? locations[0]._id : '' }}
          onSubmit={onSubmit}
        >
          {({ status, isSubmitting, dirty, setStatus }) => {
            return (
              <Form dirty={!!dirty && !isSubmitting}>
                <Alert onClose={() => setStatus()} show={!!status?.msg}>
                  {status?.msg}
                </Alert>
                <Alert variant="warning" show={!locations.length}>
                  {t('punch.NO_LOCATIONS')}
                </Alert>

                <Select name="locationId" module="punch.punchLocation" required options={locations} />

                <Button type="submit" isSubmitting={isSubmitting} text="auth.SUBMIT" />
                <Prompt when={dirty ? !isPunchToken : false} message="Are you sure you want to leave?" />
              </Form>
            )
          }}
        </Formik>
      </Card.Body>
    </MerinioCard>
  )
}

export default PunchLocation
